import { Routes } from "@angular/router";
import { maintenanceGuard } from "../shared/guards/auth-guard.guard";
import { blogPostResolver } from "./blog/blog-post/blog-post.resolver";

// All page components are lazy-loaded so they stay out of the initial bundle —
// these marketing/content pages are not needed for the first paint of /shop or /home.
export const pagesRoutes: Routes = [
  {
    path: 'pages',
    title: 'Pages',
    loadComponent: () => import('./pages.component').then(m => m.PagesComponent),
    canActivate: [maintenanceGuard],
    canActivateChild: [maintenanceGuard],
    children: [
      {
        path: 'how-it-works',
        title: 'How it works',
        loadComponent: () => import('./how-it-works/how-it-works.component').then(m => m.HowItWorksComponent)
      },
      {
        path: 'sustainable',
        title: 'Sustainable',
        loadComponent: () => import('./sustainable/sustainable.component').then(m => m.SustainableComponent)
      },
      {
        path: 'recipes',
        title: 'Recipes',
        loadComponent: () => import('./recipes/recipes.component').then(m => m.RecipesComponent)
      },
      {
        path: 'recipe-detail',
        title: 'Recipe Detail',
        loadComponent: () => import('./recipe-detail/recipe-detail.component').then(m => m.RecipeDetailComponent)
      },
      {
        path: 'faq',
        title: 'FAQ',
        loadComponent: () => import('./faq/faq.component').then(m => m.FaqComponent),
      },
      {
        path: 'procurement-standards',
        title: 'Procurement standards',
        loadComponent: () => import('./procurement-standards/procurement-standards.component').then(m => m.ProcurementStandardsComponent),
      },
      {
        path: 'producers',
        title: 'Producers',
        loadComponent: () => import('./producers/producers.component').then(m => m.ProducersComponent)
      },
      {
        path: 'producers/:producerUrl',
        title: 'Producer Detail',
        loadComponent: () => import('./producers/producer-detail/producer-detail.component').then(m => m.ProducerDetailComponent)
      },
      {
        path: 'blog',
        title: 'Blog',
        loadComponent: () => import('./blog/blog.component').then(m => m.BlogComponent)
      },
      {
        path: 'blog-post/:category/:title',
        title: 'Blog Post',
        loadComponent: () => import('./blog/blog-post/blog-post.component').then(m => m.BlogPostComponent),
        resolve: { blogPost: blogPostResolver }
      },
      {
        path: 'gift-cards',
        title: 'Gift Cards',
        loadComponent: () => import('./gift-cards/gift-cards.component').then(m => m.GiftCardsComponent)
      },
      {
        path: 'why-farmbox',
        title: 'Why Farmbox',
        loadComponent: () => import('./why-farmbox/why-farmbox.component').then(m => m.WhyFarmboxComponent)
      },
    ]
  },
];
